import React from 'react';
import { styled } from 'styled-components';
import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import { useTranslation } from 'react-i18next';
import colors from '../styles/colors';

export interface RetryMessageProps {
  message: string;
  onRetry: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 272px;
`;

const StyledInlineMessage = styled(InlineMessage)`
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  min-width: 125px;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem 2.5rem;
  box-sizing: border-box;
  background: ${colors.background.default};
  border: 1px solid ${colors.neutral.grey300};
  border-radius: 2px;
`;

const RetryMessage: React.FC<RetryMessageProps> = ({ message, onRetry }) => {
  const { t } = useTranslation();

  const handleOnClick = (e: React.SyntheticEvent<object>): void => {
    e.preventDefault();

    onRetry();
  };

  return (
    <Container>
      <Box data-cy="retry-message">
        <StyledInlineMessage
          subtle
          variant="negative"
          body={message}
          role="alert"
          aria-live="assertive"
        />
        <StyledButton
          onClick={handleOnClick}
          text={t('components.retryMessage.buttonText')}
        />
      </Box>
    </Container>
  );
};

export default RetryMessage;
